// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.floorplans.RentalManagerUserPropertyFloorPlanLayoutWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserPropertyFloorPlanLayoutUploadRequestWebDto,
  UserPropertyFloorPlanLayoutUploadResponseWebDto,
} from '../..';

interface UploadParams {
  floorPlanId: string;
  sourceUrl?: string;
}

export const RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_upload_Path =
  '/api/web/v1/users/properties/floorPlans/layouts/upload';

/**
 * Upload a property layout
 */
export const RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_upload = (
  getParams: UploadParams,
  postData: UserPropertyFloorPlanLayoutUploadRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    UploadParams,
    UserPropertyFloorPlanLayoutUploadRequestWebDto,
    UserPropertyFloorPlanLayoutUploadResponseWebDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_upload_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
      isFormData: true,
    },
    client,
  );
};
